"use Client";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface DropdownItem {
  id: number;
  title: string;
  [key: string]: string | number; // Allows additional properties dynamically
}
interface dropdownProps {
  titleClass?: string;
  title: string | number;
  content: DropdownItem[]; // Accepts an array of objects with at least `id` and `title`
  icon?: React.ReactNode;
  onSelect: (item: DropdownItem) => void;
}

export function Dropdown({
  titleClass,
  title,
  content,
  icon,
  onSelect,
}: dropdownProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className="flex items-center gap-1">
          {icon}
          <p className={titleClass}>{title}</p>
        </div>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        side="bottom"
        align="start"
        sideOffset={4}
        className="w-[270px] bg-white rounded-3xl shadow-[0px_4px_12px_0px_#00000040]"
      >
        {content.map((item) => (
          <DropdownMenuItem
            key={item.id}
            onClick={() => onSelect(item)}
            className={`py-[10px] px-3 font-semibold text-black text-sm sm:text-base md:text-lg leading-[27px] ff_poppins border-b-[#5e57eb] cursor-pointer hover:bg-[#c8c8c8] duration-300 ease-linear ${
              item.id === content.length ? "rounded-b-0" : "border-b-[0.25px]"
            } ${title === item.title && "bg-[#c8c8c8]"}`}
          >
            {item.title}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
